import { ApiResponse } from "../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../Services/common/Axios.service";


const SERVICE_URL = ServiceEndPoint.account_service; 

export async function submitCustomerForm(payload:any): Promise<ApiResponse<any>>{
  const response = await axiosService.post(`${SERVICE_URL}customers`, payload);
  return response.data;
}
export async function submitCustomerShipTo(payload:any): Promise<ApiResponse<any>>{
  const response = await axiosService.post(`${SERVICE_URL}customer-ship-tos`, payload);
  return response.data;
}
export async function updateCustomerShipTo(id:string,payload:any): Promise<ApiResponse<any>>{
  const response = await axiosService.put(`${SERVICE_URL}customer-ship-tos/${id}`, payload);
  return response.data;
}
export async function getCustomerDetails(id?:string): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${SERVICE_URL}customers/${id}`);
    return response.data;
}
export async function updateCustomer(id:string,payload:any): Promise<ApiResponse<any>> {
  const response = await axiosService.put(`${SERVICE_URL}customers/${id}`,payload);
  return response.data;
}
export async function getcustomerShiptoList(payload:any): Promise<ApiResponse<any>> {
  const response = await axiosService.post(`${SERVICE_URL}customer-ship-tos/query`,payload);
  return response.data;
}
export async function getcustomerShiptoById(id:any): Promise<ApiResponse<any>> {
  const response = await axiosService.get(`${SERVICE_URL}customer-ship-tos/${id}`);
  return response.data;
}
export async function deleteCustomer(id:any): Promise<ApiResponse<any>> {
  const response = await axiosService.delete(`${SERVICE_URL}customers/${id}`);
  return response.data;
}
export async function deleteCustomerShipto(id:any): Promise<ApiResponse<any>> {
  const response = await axiosService.delete(`${SERVICE_URL}customer-ship-tos/${id}`);
  return response.data;
}